module.exports = "<div class=\"embeddedPage\">\r\n    <div class=\"embeddedPage-content\" ui-view=\"embedded-base-content\"></div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/embedded/embedded-base-page.html
// module id = 627
// module chunks = 0